import { createFileRoute } from "@tanstack/react-router";
import { RelatorioForaPadrao } from "pages/relatorios/pages/leituras_fora_padrao";

export const Route = createFileRoute("/a/relatorios/leituras-fora-padrao")({
	component: RelatorioForaPadrao,
});
